import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function cancelInvoicingSession(
  appointmentId: string,
  cancelStatus: "cancel" | "late_cancel" | "no_show",
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/invoicing/cancel/${appointmentId}`,
    {
      method: "POST",
      body: JSON.stringify({
        appointment_status: cancelStatus,
      }),
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to cancel invoicing session: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
